
import BadgeIcon from "../../../Icons/BadgeIcon";
import WatchYtVideo from "../Popups/WatchYtVideo";

import React, { useState } from "react";

function YtWatchVideo({ entryjson, inputs, setInputs, saveMemberEntry }) {
    // const { showToast } = useToast();

    const entrydet = JSON.parse(entryjson.entry);
    const [dialogs, setDialogs] = useState({
        watchytvideo: false,

    });
    const [nxtgoalbtn, setnxtgoalbtn] = useState('');


    const saveEntry = () => {

        saveMemberEntry();

    }
    const handleDialogButtonClick = (dialog) => {

        setnxtgoalbtn(1)
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [dialog]: true,
        }));


    };
    const handleCloseDialog = (dialog,) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [dialog]: false,
        }));
    };
    function getVideodetail(entrydet) {

        const yturl = isYouTubeUrl(entrydet.video_url);
        if (yturl) {
            const ytid = getYouTubeVideoId(entrydet.video_url);
            return <div><iframe allow="autoplay; fullscreen" title="video" allowFullScreen style={{ width: '500px', height: '300px' }} className="rounded-md" src={`https://www.youtube.com/embed/${ytid}`}></iframe></div>;
        }


    }


    function getVideothumb(entrydet) {

        const yturl = isYouTubeUrl(entrydet.video_url);
        if (yturl) {
            const ytid = getYouTubeVideoId(entrydet.video_url);
            return <div style={{ position: 'relative', display: 'inline-block' }}>
                <span
                    style={{ cursor: 'pointer' }}
                    title="Click here"
                    onClick={() => handleDialogButtonClick('watchytvideo')}
                >
                    <img
                        src={`https://img.youtube.com/vi/${ytid}/maxresdefault.jpg`}
                        alt="no-image"
                        style={{ width: '180px' }}
                    />

                    {/* Play Button */}
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '30px',
                            height: '30px',
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <svg
                            className="svg-fill-color"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        // You can change this color
                        >
                            <polygon points="5 3 19 12 5 21 5 3" />
                        </svg>
                    </div>
                </span>
            </div>
                ;
        }


    }
    function getYouTubeVideoId(url) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com(?:\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=))|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    function isYouTubeUrl(url) {
        const youtubePattern = /^(https?:\/\/)?(www\.)?(youtube|youtu|youtube-nocookie|youtu.be)\.(com|be)\/(watch\?v=|embed\/|v\/|e\/|.+\/videoseries\?v=|[a-zA-Z0-9_-]{11})(\S*)$/;
        return youtubePattern.test(url);
    }


    return (

        <div className="cursor-default">
            <WatchYtVideo isOpen={dialogs.watchytvideo} onClose={() => handleCloseDialog("watchytvideo")} title={entrydet?.tooltip_text} ytvideo={getVideodetail(entrydet)} />

            <div className="flex flex-col md:flex-row justify-between">
                <div className="md:w-[440px]">
                    <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1">{entrydet?.headline}</h4>
                    <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px]">{entrydet?.description}</p>
                </div>
                <div className="hidden min-[426px]:block">
                    <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
            <div className="pt-2">
                {getVideothumb(entrydet)}
                {/* <button onClick={() => handleDialogButtonClick('watchytvideo')} className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7] hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]`}>Watch Video</button> */}
            </div>
            <div className="flex items-center justify-between">
                <div className="pt-2">
                    <button onClick={(e) => { if (nxtgoalbtn === 1) { saveEntry(); } }} disabled={!nxtgoalbtn} className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7] ${!nxtgoalbtn ? 'opacity-50 cursor-not-allowed' : ' hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]'}`}>Earn Points</button>
                </div>
                <div className="pt-2">
                    <span class="earn_points_btn ml-2 bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7] sm:hidden">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default YtWatchVideo;